@if (item.hasIcon()) {
  <app-icon [icon]="item.icon!" />
}

<span>{{ item.label }}</span>
